import React from "react";
import Close from "../../../Icons/Close";
import "./ConfirmDialog.css";

const ConfirmDialog = ({
  optInText,
  optOutText,
  headerText,
  subheaderText,
  onOptInClick,
  onOptOutClick
}) => (
  <div className="confirmation-container">
    <div className="confirmation-top-bar">
      <div className="confirmation-close-icon-button" >
        <Close className="close-icon confirmation-close-icon" onClick={onOptOutClick} />
      </div>
    </div>
    <div className="confirmation-logo" />
    <div className="confirmation-header-text">
      <span>{ headerText }</span>
    </div>
    <div className="confirmation-subheader-text">
      <span>{ subheaderText }</span>
    </div>
    <div className="confirmation-button-container">
      <button className="confirmation-opt-in-button" onClick={ onOptInClick }>
        <span>{ optInText }</span>
      </button>
      <button className="confirmation-opt-out-button" onClick={ onOptOutClick }>
        <span>{ optOutText }</span>
      </button>
    </div>
  </div>
);

export default ConfirmDialog;
